<template>
    <div style="margin-top:-10px"> 
            <el-menu default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect"  
            background-color="#fff"
        text-color="#000"
        active-text-color="#ffd04b">
        <el-menu-item index="1">处理中</el-menu-item> 
        <el-menu-item index="2">已关闭</el-menu-item>  
        <el-button  type="primary" size="small"  style="float:right;margin-top:5px;margin-left:10px;"  @click="addBind" >创建工单</el-button> 
        <el-button  type="primary" size="small"  style="float:right;margin-top:5px;"  @click="refresh" >工单刷新</el-button>
         
            
        </el-menu>
        <div style='margin-top:20px'></div>
        <div class="line"></div>
            <v-content1 :style="show1"></v-content1>
            <v-content2 :style="show2"></v-content2> 
    </div>
</template>

<script>
import vContent1 from './WOHandle.vue';
import vContent2 from './WOEnd.vue'; 
import Bus from "../common/woNavBus";
export default { 
    data() {
        return { 
            show1:"display:block",
            show2:"display:none",   
            index:'1',     
        }
    },
    components: { 
        vContent1,
        vContent2, 
    },
    methods: {
        addBind(){
            if(this.index==1){
                Bus.$emit("addBind");
            }else{
                Bus.$emit("addBind2");  
            }
             
        },
        refresh(){
            history.go(0); 
        },
        //在线销户
        destoryPhone(){
            window.open("https://doc.weixin.qq.com/forms/AF0AYgdVAD0AVcA2QapACQnrOLkAlnRBf");
        },
        handleSelect(key, keyPath) {   
            this.index = key;
            if(key==1){ this.show1 = "display:block";this.show2 = "display:none"; }
            if(key==2){ this.show1 = "display:none";this.show2 = "display:block"; } 
        }
    }
}
</script>
<style scoped>
.sidebar-el-menu, .el-menu {
    height: 40px;
    background: #fff !important; 
} 
.el-menu-item.is-active {
    color: #409EFF !important; 
    background: #fff !important; 
    border-bottom-color:#409EFF;
}
.el-menu-item:hover{
    color: #409EFF !important; 
    background: #fff !important;
    border-bottom: 2px solid #409EFF;
}

.el-menu--horizontal>.el-menu-item {
    float: left;
    height: 40px;
    line-height: 40px;
    margin-right:10px;
}
.el-menu.el-menu--horizontal {
    border-top: solid 1px #ddd;
    border-left: solid 1px #ddd;
    border-right: solid 1px #ddd;
}

</style>
